import {
    SET_SEARCH_START_TIME
} from '../../actions';

const initialState = {
    startTime: 0
}

function searchTimeReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_SEARCH_START_TIME:
            newState.startTime = action.startTime;
            return newState;

        default:
            return state;

    }

}

export default searchTimeReducer;
